/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchStreamErrorCode } from './SearchStreamErrorCode';
import {
    SearchStreamErrorCodeFromJSON,
    SearchStreamErrorCodeFromJSONTyped,
    SearchStreamErrorCodeToJSON,
    SearchStreamErrorCodeToJSONTyped,
} from './SearchStreamErrorCode';

/**
 * Terminal error event. The stream closes immediately after this
 * fires. `code` enumerates the failure mode for client-side handling.
 * 
 * @export
 * @interface SearchStreamError
 */
export interface SearchStreamError {
    /**
     * 
     * @type {string}
     * @memberof SearchStreamError
     */
    type: SearchStreamErrorTypeEnum;
    /**
     * 
     * @type {SearchStreamErrorCode}
     * @memberof SearchStreamError
     */
    code: SearchStreamErrorCode;
    /**
     * 
     * @type {string}
     * @memberof SearchStreamError
     */
    message: string;
}


/**
 * @export
 */
export const SearchStreamErrorTypeEnum = {
    Error: 'error'
} as const;
export type SearchStreamErrorTypeEnum = typeof SearchStreamErrorTypeEnum[keyof typeof SearchStreamErrorTypeEnum];


/**
 * Check if a given object implements the SearchStreamError interface.
 */
export function instanceOfSearchStreamError(value: object): value is SearchStreamError {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SearchStreamErrorFromJSON(json: any): SearchStreamError {
    return SearchStreamErrorFromJSONTyped(json, false);
}

export function SearchStreamErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStreamError {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'code': SearchStreamErrorCodeFromJSON(json['code']),
        'message': json['message'],
    };
}

export function SearchStreamErrorToJSON(json: any): SearchStreamError {
    return SearchStreamErrorToJSONTyped(json, false);
}

export function SearchStreamErrorToJSONTyped(value?: SearchStreamError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'code': SearchStreamErrorCodeToJSON(value['code']),
        'message': value['message'],
    };
}

